import {
  buildCourseKnowledgeQueryParams,
  consts as courseConsts,
  opts as courseOpts,
} from '@views/training/training-course.constants'

export const consts = {
  ...courseConsts,
  QUESTION_TYPE_SINGLE: 1, // 单选题
  QUESTION_TYPE_MULTI: 2, // 多选题
  QUESTION_TYPE_FILL_BLANK: 3, // 填空题

  QUESTION_STATUS_NEW: 1, // 新创建
  QUESTION_STATUS_USING: 2, // 使用中
  QUESTION_STATUS_UNUSED: 3, // 未使用
  QUESTION_STATUS_BANNED: 4, // 已作废
}

export const opts = {
  targetUserMaps: courseOpts.targetUserMaps,
  isCommonMaps: courseOpts.isCommonMaps,
  statusMaps: [
    {value: consts.QUESTION_STATUS_NEW, label: '新创建'},
    {value: consts.QUESTION_STATUS_UNUSED, label: '未使用'},
    {value: consts.QUESTION_STATUS_USING, label: '使用中'},
    {value: consts.QUESTION_STATUS_BANNED, label: '已作废'},
  ],
  questionTypeMaps: [
    {value: consts.QUESTION_TYPE_SINGLE, label: '单选题'},
    {value: consts.QUESTION_TYPE_MULTI, label: '多选题'},
    {value: consts.QUESTION_TYPE_FILL_BLANK, label: '填空题'},
  ],
}

export function createOptionUuid () {
  return `opt${Math.random().toString(16).slice(2)}${Date.now()}`
}

export function createDefaultQuestionOptions () {
  return ['A', 'B', 'C', 'D'].map(letter => ({
    uuid: createOptionUuid(),
    title: `选项${letter}`,
  }))
}

export function getOptionLetter (index) {
  return String.fromCharCode(65 + index)
}

export function resetQuestionAnswerByType (type) {
  return Number(type) === consts.QUESTION_TYPE_MULTI ? [] : ''
}

export function isChoiceQuestion (type) {
  return [consts.QUESTION_TYPE_SINGLE, consts.QUESTION_TYPE_MULTI].includes(Number(type))
}

export function isNumericAnswer (value) {
  return /^-?\d+(\.\d+)?$/.test(String(value).trim())
}

export function getQuestionTypeLabel (value) {
  const item = opts.questionTypeMaps.find(option => option.value === Number(value))
  return item ? item.label : '-'
}

export function getQuestionStatusLabel (value) {
  const item = opts.statusMaps.find(option => option.value === Number(value))
  return item ? item.label : '-'
}

export function getQuestionStatusType (status) {
  switch (Number(status)) {
    case consts.QUESTION_STATUS_UNUSED:
      return 'success'
    case consts.QUESTION_STATUS_USING:
      return 'primary'
    case consts.QUESTION_STATUS_BANNED:
      return 'default'
    default:
      return 'warning'
  }
}

export function getQuestionStatusActions (status, isSuperAdmin = true) {
  if (!isSuperAdmin) {
    return []
  }
  switch (Number(status)) {
    case consts.QUESTION_STATUS_UNUSED:
    case consts.QUESTION_STATUS_NEW:
      return [
        {name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingQuestion', successText: '作废成功'},
      ]
    case consts.QUESTION_STATUS_BANNED:
      return [
        {name: 'active', label: '激活', type: 'primary', apiName: 'activeTrainingQuestion', successText: '激活成功'},
      ]
    default:
      return []
  }
}

export function isQuestionRelationEditLocked (id, status) {
  return Number(id) > 0 && [
    consts.QUESTION_STATUS_UNUSED,
    consts.QUESTION_STATUS_USING,
    consts.QUESTION_STATUS_BANNED,
  ].includes(Number(status))
}

export function isQuestionBaned (id, status) {
  return Number(id) > 0 && Number(status) === consts.QUESTION_STATUS_BANNED
}

export function isQuestionUsedOrBaned (id, status) {
  return Number(id) > 0 && (Number(status) === consts.QUESTION_STATUS_BANNED || Number(status) === consts.QUESTION_STATUS_USING)
}

export function buildQuestionKnowledgeQueryParams (form) {
  return buildCourseKnowledgeQueryParams(form)
}

export function getQuestionSubmitPayload (form) {
  const payload = {
    target_usertype: form.target_usertype,
    is_common: form.is_common,
    customerid: Number(form.is_common) === consts.IS_COMMON_SHARED ? 0 : form.customerid,
    training_knowledge_id: form.training_knowledge_id,
    question_type: form.question_type,
    question_json: {
      title: form.title,
      sample_files: form.sample_files || [],
      question_analysis: {
        analysis_text: form.analysis_text || '',
        analysis_files: form.analysis_files || [],
      },
      standard_answer: form.standard_answer,
    }
  }

  if (isChoiceQuestion(form.question_type)) {
    payload.question_json.options = form.options || []
  }

  return payload
}



// WEBPACK FOOTER //
// ./src/views/training/training-question.constants.js